var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 185,
    viewBox: "0 0 277 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M258.185 45.6572C231.675 25.4452 178.862 20.7156 123.068 36.4014C67.274 52.0871 24.6462 83.6157 12.5321 114.667L3.37891 117.249L10.4982 142.589C21.2241 180.742 89.0057 195.087 161.887 174.603C234.769 154.119 285.181 106.583 274.449 68.474L267.329 43.1338L258.185 45.6572Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.755 149.265C227.644 128.786 278.04 81.2461 267.317 43.082C256.594 4.91784 188.813 -9.41873 115.924 11.0607C43.0349 31.5401 -7.36084 79.0803 3.36198 117.244C14.0848 155.409 81.8657 169.745 154.755 149.265Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.483 126.902C205.952 110.755 246.355 75.6526 238.726 48.4982C231.096 21.3439 178.323 12.4205 120.854 28.5673C63.3851 44.7142 22.9821 79.8169 30.6116 106.971C38.241 134.126 91.0137 143.049 148.483 126.902Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin5);
export default __webpack_public_path__ + "static/media/coin5.3c163c1cac053b2a0ad17e4fb0e21f52.svg";
export { ForwardRef as ReactComponent };